import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import { Query } from "react-apollo";

import ErrorBoundary from "components/Library/ErrorBoundary";
import { FRONTEND_ROOT } from "config/constants";
import TAG_STREAM_HELMET_QUERY from "./TagStreamHelmet.graphql";

export default function TagStreamHelmet({ slug }) {
  return (
    <ErrorBoundary>
      <Query query={TAG_STREAM_HELMET_QUERY} variables={{ slug }}>
        {({ loading, data }) => {
          if (loading) return null;

          const { stream } = data;
          return (
            <Helmet>
              <title>{stream.displayName} - Axios</title>
              <meta
                property="og:url"
                content={`${FRONTEND_ROOT}/tag/${stream.lookup}/`}
              />
              <meta
                property="og:title"
                content={`${stream.displayName} on Axios`}
              />
            </Helmet>
          );
        }}
      </Query>
    </ErrorBoundary>
  );
}

TagStreamHelmet.propTypes = {
  slug: PropTypes.string.isRequired,
};
